import { render } from "./SignAdmin.vue?vue&type=template&id=6232e847"
import script from "./SignAdmin.vue?vue&type=script&lang=js"
export * from "./SignAdmin.vue?vue&type=script&lang=js"

import "./SignAdmin.vue?vue&type=style&index=0&id=6232e847&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__